<template>
	<div class="container-fluid">
		<div class="form-row">
			<div class="col-12">
				<div class="slidercaptcha card">
					<div class="card-header">
						<table>
							<td align="left">
								<span>请完成验证</span>
							</td>
							<td align="right">
								<vxe-button type="text" class="tool-btn _icon_button" title="刷新" @click="reset">
									<i class="iconfont icon-zhongzhi iconSize "></i>
								</vxe-button>
								<vxe-button type="text" class="tool-btn _icon_button" title="退出" @click="closeCallback">
									<i class="iconfont icon-close iconSize "></i>
								</vxe-button>
							</td>
						</table>
					</div>
					<div class="card-body">
						<div id="captcha">
							<div class="sildeimg">
								<!-- <img src="../../public/static/images/Pic0.jpg" /> -->
							</div>
							<div class="sliderContainer">
								<div class="sliderbg"></div>
								<div class="sliderMask" style="width: 0px;">
									<div class="slider" style="left: 0px;">
										<i class="iconfont icon-Arrow iconSize "></i>
									</div>
								</div>
								<!-- <span class="sliderText" data-text="向右滑动填充拼图">向右滑动填充拼图</span> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'drag',
		props: {
			callback: {
				type: Function,
				default: () => {}
			},
			closeCallback: {
				type: Function,
				default: () => {}
			}
		},
		data() {
			return {
				x: 0,
				y: 0,
				options: { //预设值
					width: 268,
					height: 155,
					fradx: 268 / 18,
					sliderL: 42, // 滑块边长
					sliderR: 9, // 滑块半径
					PI: Math.PI,
					loadingText: '正在加载中...',
					failedText: '再试一次',
					barText: '向右滑动填充拼图'
				},
				img: null,
				canvasCtx: null,
				blockCtx: null,
				block: null,
				canvas: null,
				unBindEvent: null,
				diffTime: 0, //操作时间
				trail: [] //路径
			}
		},
		computed: {
			SfontSize() {
				let fontSize = document.documentElement.style.fontSize;
				fontSize = Number(fontSize.replace('px', ''));
				fontSize = isNaN(fontSize) || fontSize == Infinity ? 18 : fontSize;
				return fontSize;
			},
			slider() {
				return $('.slider');
			},
			sliderContainer() {
				return $('.sliderContainer');
			},
			sliderMask() {
				return $('.sliderMask');
			},
			text() {
				return $('.sliderbg');
			},
			VaryArr() {
				return this.$store.getters.dragV;
			}
		},
		methods: {
			//从服务器随机一张图片
			initImg() {
				//首先获取图片，然后缓存图片
				//创建画布
				var options = this.options;
				var that = this;
				options.width = $('.sildeimg').width(); //显示固定值 之后需要进行计算
				options.height = Math.round(options.width * 155 / 278);

				var isIE = window.navigator.userAgent.indexOf('Trident') > -1;
				var getRandomNumberByRange = function(start, end) {
					return Math.round(Math.random() * (end - start) + start);
				};
				var drawImg = function(ctx, operation) {
					var l = options.sliderL;
					var r = options.sliderR;
					var PI = options.PI;
					var x = that.x;
					var y = that.y;
					ctx.beginPath()
					ctx.moveTo(x, y)
					ctx.arc(x + l / 2, y - r + 2, r, 0.72 * PI, 2.26 * PI)
					ctx.lineTo(x + l, y)
					ctx.arc(x + l + r - 2, y + l / 2, r, 1.21 * PI, 2.78 * PI)
					ctx.lineTo(x + l, y + l)
					ctx.lineTo(x, y + l)
					ctx.arc(x + r - 2, y + l / 2, r + 0.4, 2.76 * PI, 1.24 * PI, true)
					ctx.lineTo(x, y)
					ctx.lineWidth = 2
					ctx.fillStyle = 'rgba(255, 255, 255, 0.7)'
					ctx.strokeStyle = 'rgba(255, 255, 255, 0.7)'
					ctx.stroke()
					ctx[operation]()
					ctx.globalCompositeOperation = isIE ? 'xor' : 'overlay'
				}
				var createCanvas = function(width, height) {
					var canvas = document.createElement('canvas');
					canvas.width = width;
					canvas.height = height;
					return canvas;
				};
				//首先创建画布
				var canvas = createCanvas(options.width - 2, options.height);
				var block = canvas.cloneNode(true) // 滑块
				this.canvas = canvas;
				this.block = block;
				$(block).attr('class', 'block')
				// var el = $('.sildeimg');
				$('.sildeimg').append($(canvas));
				$('.sildeimg').append($(block));
				var canvasCtx = canvas.getContext('2d');
				var blockCtx = block.getContext('2d');
				var img = new Image();
				img.crossOrigin = "Anonymous";
				var L = options.sliderL + options.sliderR * 2 + 3; // 滑块实际边长
				var loadCount = 0;
				img.onerror = function() {
					loadCount++;
					if (window.location.protocol === 'file:') {
						loadCount = 3;
						console.error("can't load pic resource file from File protocal. Please try http or https");
					}
					if (loadCount >= 3) {
						that.text.text('加载失败').addClass('text-danger');
						return;
					}
					img.src = "static/images/Pic0.jpg";
				}
				img.onload = function() {
					loadCount = 0;
					that.text.removeClass('text-danger');
					// 随机创建滑块的位置
					that.x = getRandomNumberByRange(L + 10, options.width - (L + 10));
					that.y = getRandomNumberByRange(10 + options.sliderR * 2, options.height - (L + 10));
					drawImg(canvasCtx, 'fill');
					drawImg(blockCtx, 'clip');
					canvasCtx.drawImage(img, 0, 0, options.width - 2, options.height);
					blockCtx.drawImage(img, 0, 0, options.width - 2, options.height);
					var y = that.y - options.sliderR * 2 - 1;
					var ImageData = blockCtx.getImageData(that.x - 3, y, L, L);
					block.width = L;
					blockCtx.putImageData(ImageData, 0, y);
					that.canvasCtx = canvasCtx;
					that.blockCtx = blockCtx;
					that.text.text(that.text.attr('data-text'));
				};
				let imgIndex = getRandomNumberByRange(0, 4);
				img.src = `static/images/Pic${imgIndex}.jpg`;
				this.img = img;
				this.text.attr('data-text', this.options.barText);
				this.text.text(this.options.loadingText);
			},
			bindEvents() { //绑定事件
				var that = this;
				var originX, originY, trail = [],
					isMouseDown = false
				var handleFalse = function() {
					return false;
				}
				$('.sildeimg').on('selectstart', handleFalse);
				var StartTime = new Date().getTime();
				var handleDragStart = function(e) {
					that.$emit('operate', true)
					if (that.text.hasClass('text-danger')) return;
					originX = e.clientX || e.touches[0].clientX;
					originY = e.clientY || e.touches[0].clientY;
					// console.log(originX,originY)//443 719
					isMouseDown = true;
					StartTime = new Date().getTime();
				};
				var handleDragMove = function(e) {
					if (!isMouseDown) return false;
					var eventX = e.clientX || (e.touches && e.touches[0].clientX);
					var eventY = e.clientY || e.touches[0].clientY;
					var moveX = eventX - originX;
					var moveY = eventY - originY;
					if (moveX < 0) {
						moveX = 0;
					}
					if (moveX + 40 > that.options.width) {
						moveX = that.options.width - 40;
					}

					that.slider.css('left', (moveX - 1) + 'px');
					var blockLeft = (that.options.width - 40 - 20) / (that.options.width - 40) * moveX;
					that.block.style.left = blockLeft + 'px';

					that.sliderContainer.addClass('sliderContainer_active');
					that.sliderMask.css('width', (moveX + 4) + 'px');
					trail.push(moveY);
				};

				var handleDragEnd = function(e) {
					that.$emit('operate', true)
					if (!isMouseDown) return false
					isMouseDown = false;
					that.diffTime = new Date().getTime() - StartTime;
					var eventX = e.clientX || (e.changedTouches && e.changedTouches[0].clientX) || (window.innerWidth -
						1)
					if (eventX == originX) return false
					that.sliderContainer.removeClass('sliderContainer_active');
					that.trail = trail;
					var {
						spliced,
						verified
					} = that.verify()
					if (spliced && verified) {
						that.sliderContainer.addClass('sliderContainer_success');
						if ($.isFunction(that.options.onSuccess)) that.options.onSuccess.call(that.$element);
						that.callback('success', {
							trail: that.trail,
							difftime: that.diffTime
						});
					} else {
						that.sliderContainer.addClass('sliderContainer_fail');
						if ($.isFunction(that.options.onFail)) that.options.onFail.call(that.$element);
						setTimeout(() => {
							that.text.text(that.options.failedText);
							that.reset();
						}, 1000);
						that.callback('fail', {
							trail: that.trail,
							difftime: that.diffTime
						});
					}
				};
				this.slider.bind('mousedown', handleDragStart);
				this.slider.bind('touchstart', handleDragStart);
				document.addEventListener('mousemove', handleDragMove);
				document.addEventListener('touchmove', handleDragMove);
				document.addEventListener('mouseup', handleDragEnd);
				document.addEventListener('touchend', handleDragEnd);
				document.addEventListener('mousedown', handleFalse);
				document.addEventListener('touchstart', handleFalse);
				this.unBindEvent = function() {
					that.slider.unbind('mousedown', handleDragStart);
					that.slider.unbind('touchstart', handleDragStart);
					document.removeEventListener('mousemove', handleDragMove)
					document.removeEventListener('touchmove', handleDragMove)
					document.removeEventListener('mouseup', handleDragEnd)
					document.removeEventListener('touchend', handleDragEnd)
					document.removeEventListener('mousedown', handleFalse)
					document.removeEventListener('touchstart', handleFalse)
				}
			},
			verify() {
				var sum = function(x, y) {
					return x + y;
				};
				var square = function(x) {
					return x * x;
				};
				var arr = this.trail // 拖动时y轴的移动距离
				var average = arr.reduce(sum) / arr.length;
				var deviations = arr.map(function(x) {
					return x - average;
				});
				var stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length);
				var left = parseInt(this.block.style.left);
				var newone = {
					trail: this.trail,
					difftime: this.diffTime
				};
				newone['code'] = this.$BH().base.hashCode(JSON.stringify(newone));
				var very = true;
				this.checkDragVerity({
					old: this.VaryArr,
					newone: newone,
					dof: (res) => {
						very = res;
					}
				});
				return {
					spliced: Math.abs(left - this.x) < 4,
					verified: stddev !== 0 && very, // 简单验证下拖动轨迹，为零时表示Y轴上下没有波动，可能非人为操作
				}
			},
			checkDragVerity({
				old,
				newone,
				dof
			}) {
				if (JSON.stringify(old) == JSON.stringify(newone) || !newone.trail || !newone.difftime || (old
						.index >= 1 && (!newone.trail || !newone.difftime)) || (newone.trail && newone.trail.length <=
					5) || newone.diffTime <= 2000) {
					console.log(1)
					dof(false);
				}
				dof(true);

			},
			clean() {
				this.canvasCtx.clearRect(0, 0, this.options.width, this.options.height);
				this.blockCtx.clearRect(0, 0, this.options.width, this.options.height);
				this.block.width = this.options.width;
				$(this.block).css('left', 0);
				// $('.sliderbg').css('left', 0);
				this.sliderMask.css('width', 0);
				this.slider.css('left', 0);
				// this.slider.style.left = 0
				// this.sliderMask.style.width = 0
			},
			reset() {
				this.sliderContainer.removeClass('sliderContainer_fail sliderContainer_success');
				this.text.attr('data-text', this.text.text());
				this.text.text(this.options.loadingText);
				//滑块和蒙版归0
				this.clean();
				//修改img的地址 会重新再次执行onload
				let imgIndex = this.getRandomNumberByRange(0, 4);
				if (this.img) this.img.src = `static/images/Pic${imgIndex}.jpg`;
				this.sliderContainer.removeClass('sliderContainer_active');
			},
			getRandomNumberByRange(start, end) {
				return Math.round(Math.random() * (end - start) + start);
			}
		},
		destroyed() {
			this.unBindEvent();
		},
		mounted() {
			this.initImg();
			this.bindEvents();
		}
	}
</script>

<style scoped>
	.container-fluid {
		-webkit-user-select: none;
		-mozt-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.sliderbg {
		-webkit-user-select: none;
		-mozt-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}

	.card-header {
		padding: .4rem 1.25rem;
		margin-bottom: 0;
		background-color: rgba(0, 0, 0, .03);
		border-bottom: 1px solid rgba(0, 0, 0, .125);
	}

	.card-body {
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		padding: 1.25rem;
	}

	.card-header table {
		width: 100%;
	}

	.card-header span {
		font-size: var(--font_normal);
	}

	.sliderContainer span {
		font-size: var(--font_normal);
	}

	.sildeimg {
		width: 100%;
		height: 149px;
		margin-bottom: 7px;
		position: relative;
	}

	.slidercaptcha {
		margin: 0 auto;
		width: 17rem;
		height: 16rem;
		border-radius: 4px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.125);
		margin-top: 1.5rem;
	}

	.slidercaptcha .card-body {
		padding: 1rem;
	}

	.slidercaptcha canvas:first-child {
		border-radius: 4px;
		border: 1px solid #e6e8eb;
	}

	.slidercaptcha.card .card-header {
		background-image: none;
		background-color: rgba(0, 0, 0, 0.03);
	}
</style>
